

/**
 * Get uuid of the current project (it will be extracted from URL using location)
 * @return {string}     UUID of the current project or empty string if current project is the default one
 */
export function getProjectUuid() {
    return location.pathname.slice(1).split("/")[0];
}
